package org.wordsapp.model

sealed class AuthState {
    data object Loading : AuthState()
    data object NotAuthenticated : AuthState()
    data class Authenticated(val email: String?) : AuthState()
    data object Demo : AuthState()
}

enum class Screen {
    Practice, Review, Statistics, WeightDistribution, Settings
}

enum class SortOrder {
    BY_WEIGHT, BY_ATTEMPTS, BY_SUCCESS_RATE
}
